/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PlatformLogs {
    getFixupPrototypeFunction() { return PlatformLogs.fixupPrototype; }

    static newInstance(model: Partial<PlatformLogs>): PlatformLogs {
        let obj = Object.assign(new PlatformLogs(), model);
        PlatformLogs.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PlatformLogs>): PlatformLogs {
        if (!model) return null;
        return PlatformLogs.newInstance(<PlatformLogs> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PlatformLogs) {
        if (!obj) return;

        models.PlatformLogs.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PlatformLogs): boolean {
        Object.setPrototypeOf(obj, PlatformLogs.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.timestamp === "string") {
            this.timestamp = new Date(<string><any>this.timestamp);
        }
    }

    /**
     * Type of logs to push
     */
    log_type: string;

    /**
     * Start time for logs to be pushed
     */
    timestamp: Date;

    /**
     * Log message to be pushed
     */
    message: string;

    /**
     * Traceback information if any
     */
    trace_back: string;

    /**
     * Run ID associated with the log
     */
    run_id: string;

    /**
     * Cluster name
     */
    cluster: string;

    /**
     * Namespace name
     */
    namespace: string;

    /**
     * Pod name
     */
    pod_name: string;

    /**
     * Container name
     */
    container: string;

    /**
     * Node name
     */
    node: string;

}
